import moment from 'moment/min/moment-with-locales';
import { toJS } from "../../lib/helpers";
import { i18n } from "../../lib/i18n";
import React from 'react';

// Components
import { Parallax } from "../../components/parallax/parallax.component";
import { Navigation } from "../../components/navigation/navigation.component";
import { Footer } from "../../components/footer/footer.component";
import { Section, Title } from "../../components/section";
import { DownloadComponent } from "../../components/download/download.component";

// Redux
import { getPrivacyStatement } from "../../store/client/client.actions";
import { connect } from 'react-redux';

// Stylesheet
import colors from '../../colors.scss';
import './privacy.container.scss';

class PrivacyContainer extends React.PureComponent {
  static getDerivedStateFromProps(props, state) {
    moment.locale(props.client.info.location.countryCode);
    return {props, state};
  }

  constructor(props) {
    super(props);

    this.props.getPrivacyStatement()
  }

  render = ({history, client} = this.props) => {
    let translatedPrivacyStatement = client.privacyStatement.translations.data.find((statement) => statement.language_code === client.info.location.countryCode);

    return (
      <div className="privacycontainer">
        <Navigation history={history}/>
        <Parallax backgroundImage={require('../../assets/images/background.jpg')} fixedHeight="20vh"/>
        <Section name="team" className="no-padding-bottom">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Title
                  className="no-padding-bottom"
                  title={i18n.translate('PRIVACY_TITLE')}
                  subTitle={`${i18n.translate('PRIVACY_SUBTITLE')} ${client.privacyStatement.version} ${moment(client.privacyStatement.revision_date).format("MMMM YYYY")}`}
                  sectionColor={colors.c1}
                  color={colors.primary}/>
              </div>
            </div>
          </div>
        </Section>
        {translatedPrivacyStatement && (
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{__html: translatedPrivacyStatement.privacy_statement}}/>
            </div>
          </div>
        )}
        <DownloadComponent history={history}/>
        <Footer history={history}/>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    client: state.client,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPrivacyStatement: () => dispatch(getPrivacyStatement())
  }
};

const connectedContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(toJS(PrivacyContainer));

export { connectedContainer as PrivacyContainer };
